import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b9b6c13a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b6c13a')) {
      api.createRecord('b9b6c13a', component.options)
    } else {
      api.reload('b9b6c13a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b9b6c13a&", function () {
      api.rerender('b9b6c13a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uAtIBOO0Bat4/JS/offershelp.vue"
export default component.exports